<template>
    <div>
        <b-modal
                ref="entityModalViewer"
        >
<!--                :title="title ? $t(title) : entity"-->
          <em-entity-viewer :entity="entity" :object="object" :title="title" :$_em-custom-vuex-mixin_configs="$_emCustomVuexMixin_configs" asCard></em-entity-viewer>
        </b-modal>
    </div>
</template>

<script>
    // import EmFormHelper from "@/components/em/EmFormHelper";
    import EmEntityViewer from "@/components/em/EmEntity/Viewer";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    // import model from '@/model/index'

    export default {
        name: "em-modal-entity-viewer",
        mixins:[emCustomVuexMixin],
        components: {EmEntityViewer},
        props: {
            'entity': String,
            'object': Object,
            title: String,
            $_emCustomVuexMixin_configs: String,
        },
        // computed: {
        //     tableColumns() {
        //         return model[this.entity].gridFields();
        //     }
        // },
        methods: {
            showModal(entityObject) {
                console.log("this is emModalEntityViewer.showModal()")
                console.log("entity:" + this.entity)
                console.log("object:")
                console.log(this.object)
                console.log("title:" + this.title)
                console.log("entityObject is")
                console.log(entityObject)
                this.$refs['entityModalViewer'].show();
            },
            hideModal() {
                this.$refs['entityModalViewer'].hide();
            }
            // getKeyValue(field) {
            //     let fieldValue = this.object[field.key]
            //     switch (field.form.type) {
            //         case 'boolean':
            //             return fieldValue ? 'Yes' : 'No'
            //         case 'select': {
            //             let selectedOption = field.form.options.filter(x => x.value === fieldValue)
            //             if (selectedOption.length > 0) {
            //                 return selectedOption[0].text;
            //             }
            //             return null
            //         }
            //         default:
            //             return fieldValue
            //     }
            // }
        }
    };
</script>